import { CustomInputMapping } from "../../redux"

export interface DataTypesTranslations {
    post: string
    question: string
    file: string
    article: string
    code: string
    poll: string
    event: string
    mail: string
    link: string
    contact: string
    company: string
    media: string
    unknown: string
}

export const defaultDataTypesTranslations: DataTypesTranslations = {
    article: 'Article',
    code: 'Code',
    event: 'Event',
    file: 'File',
    link: 'Link',
    mail: 'Mail',
    poll: 'Poll',
    post: 'Post',
    question: 'Question',
    company: 'Company',
    contact: 'Contact',
    media: 'Media',
    unknown: 'Unknown'
}

export const getDataTypeName = (translations: DataTypesTranslations, customInputMappings: CustomInputMapping[]) => (dataType: string) => {
    switch (dataType) {
        case 'post':
            return translations.post
        case 'question':
            return translations.question
        case 'file':
            return translations.file
        case 'htmlwysiwyg':
        case 'article':
            return translations.article
        case 'code':
            return translations.code
        case 'poll':
            return translations.poll
        case 'event':
            return translations.event
        case 'mail':
            return translations.mail
        case 'bookmark':
            return translations.link
        case 'contact':
            return translations.contact
        case 'company':
            return translations.company
        case 'media':
            return translations.media
        default:
            const customInputMapping = customInputMappings.find(x => x.customDataMapping.dataTypeFilter === dataType)
            if (customInputMapping) {
                return customInputMapping.title
            } else {
                return translations.unknown
            }
    }
}